import React, {useEffect} from 'react';
import {initializeApp} from "firebase/app";
import {getFirestore, doc, setDoc, serverTimestamp} from "firebase/firestore";
import {getMessaging, getToken} from "firebase/messaging";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from "firebase/auth";
import {SnackbarProvider} from "notistack";
import {useUser} from "./UserContext.js";
import TraderPage from './trader/TraderPage.js';
import Login from './Login.js';
import AdminPage from './admin/AdminPage.js';
import './Styles.css';
import {Button} from '@mui/material';
import {ExitToAppRounded} from '@mui/icons-material';

const firebaseConfig = {
  apiKey: "AIzaSyAWcV6LpSZeiAw5dPUa1RzmQlYIVY9OFZY",
  authDomain: "locatesapp.firebaseapp.com",
  projectId: "locatesapp",
  storageBucket: "locatesapp.appspot.com",
  messagingSenderId: "342161144699",
  appId: "1:342161144699:web:5414bd98728a1e6fc45bde",
  measurementId: "G-VR7J9G2QDQ",
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

function App() {
  const [appV, setAppV] = React.useState("");
  const {appUser} = useUser();

  const messaging = getMessaging(app);

  useEffect(() => {
    async function uploadTokenToFirestore(token) {
      const db = getFirestore();
      const docRef = doc(db, "admin-tokens", appUser.id);
      await setDoc(docRef, {
        token: token,
        updatedAt: serverTimestamp(),
      }, {merge: true});
    }
    const requestPermission = async () => {
      try {
        // Request permission to send notifications
        await Notification.requestPermission();
        if (Notification.permission === "granted") {
          // Get the messaging token
          const token = await getToken(messaging);
          if (token?.length > 0) {
            uploadTokenToFirestore(token);
            console.log("Token: ", token);
          } else
            console.log("No token returned: ", token);
        } else {
          console.log("Unable to get permission to notify.");
        }
      } catch (error) {
        console.error("Permission denied", error);
      }
    };
    if (appUser?.role === "admin") {
      requestPermission();
    }
  }, [appUser, messaging]);

  const [roleMessage, setRoleMessage] = React.useState("");
  useEffect(() => {
    if (appUser) {
      switch (appUser.role) {
        case "admin":
          setRoleMessage("Admin");
          break;
        case "user":
          setRoleMessage("Trader");
          break;
        default:
          setRoleMessage("No role assigned!");
      }
    } else {
      setRoleMessage("Not signed in!");
    }
  }, [appUser]);

  fetch('/manifest.json')
    .then(response => response.json())
    .then(data => setAppV(data.version));

  function signOut() {
    if (appUser?.role === "admin" && appUser?.id) {
      removeTokenFromFirestore();
    }
    const auth = getAuth();
    auth.signOut();
  }

  async function removeTokenFromFirestore() {
    const db = getFirestore();
    const docRef = doc(db, "admin-tokens", appUser.id);
    await setDoc(docRef, {
      token: "",
      updatedAt: serverTimestamp(),
    }, {merge: true});
  }

  return (
    <SnackbarProvider maxSnack={3}>
      < div className='app-container'>
        <div className="container">
          <div className="left">
            <img src="logo-appbar.png" width="64px" alt="Locates Logo" />
          </div>
          <div className="centered">
            {roleMessage}
          </div>
          <div className="right">
            <Button variant="outlined" startIcon={<ExitToAppRounded />} onClick={signOut} />
          </div>
        </div>
        {appUser?.role === "admin" && <AdminPage />}
        {appUser?.role === "user" && < TraderPage />}
        {(!appUser || (appUser?.role === "none")) && <Login />}
        <div className="container">
          <div className="left" />
          <div className="centered" />
          <div className="right-foot">
            Version {appV}
          </div>
        </div>
      </div>
    </SnackbarProvider>
  );
}

export default App;